<template>
    <label class="video-control_select-wrap">
        Качество:
        <select class="quality-select video-control_select default-select" v-model="qualityValue">
            <option value="-1">Авто</option>
            <option v-for="(quality, level) in availableQuality" :key="level" :value="level">{{quality.name}}</option>
        </select>
    </label>
</template>
<script>
    import Hls from 'hls.js';

//    import { mapState, mapActions } from 'vuex';

    export default {
        data() {
            return {
                qualityValue: this.quality,
                availableQuality: [],
                qualityNames: ['мобильный', 'эко', 'стандарт', 'премиум', 'HD']
            }
        },
        mounted() {
        },
//        computed: {
//            ...mapState({
//                hls: state => state.video.hls
//            })
//        },
        props: ['quality', 'hls'],
        methods: {
//            ...mapActions([
//                'changeVideoQuality'
//            ]),
            makeKb(value) {
                return Math.round(value / 1024) + 'kb';
            }
        },
        watch: {
            qualityValue() {
//                this.changeVideoQuality(+this.qualityValue);
                this.hls.currentLevel = +this.qualityValue;
            },
            hls() {
                this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                    console.log("manifest loaded, found " + data.levels.length + " quality level");
                    this.availableQuality = data.levels;
                    for (let level in this.availableQuality) {
                        if (!this.availableQuality.hasOwnProperty(level)) continue;
                        let quality = this.availableQuality[level];
                        quality.name = this.qualityNames[level] || this.makeKb(quality.bitrate);
                    }
                });
            }
        }
    }
</script>
<style>
    /*.quality-select {*/
        /*margin: 0px 20px;*/
    /*}*/
</style>


// WEBPACK FOOTER //
// QualitySelect.vue?d397f71a